export { default as OrganicTabsDashboard } from "./Tabs/OrganicTabsDashboard";
